var map = {
	"./Deliveroo.svg": "mIx6",
	"./Glovo.svg": "gCK0",
	"./Just Eat.svg": "4HAL",
	"./Uber Eats.svg": "t3Wm",
	"./ca.svg": "TKvO",
	"./de.svg": "hkB+",
	"./deliveroo_gestion.svg": "o4Kn",
	"./en.svg": "tc7e",
	"./es.svg": "FxNG",
	"./eu.svg": "tnaW",
	"./fr.svg": "w3lL",
	"./globe.svg": "rKBF",
	"./glovo_gestion.svg": "OHdp",
	"./it.svg": "OMyd",
	"./justeat_gestion.svg": "RI3b",
	"./pt.svg": "By/3",
	"./stars.svg": "jOi1",
	"./ubereats_gestion.svg": "J5Oh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UKcq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.svg$
// module id = UKcq
// module chunks = 4